import Vue from "vue";
import Router from "vue-router";
import TrialForm from "@/components/trial-form";
import SandboxForm from "@/components/sandbox-form";
import ThankYou from "@/components/thank-you";
import CookiePass from "@/components/cookie-pass";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/brightspace/:segment(k-12|he|corp|curriculum)/thank-you/", // Limit the segment values
      component: ThankYou
    },
    {
      path: "/:segment(curriculum|adventure)/thank-you/", // Limit the segment values
      component: ThankYou
    },
    {
      path: "/:segment(k-12|he|corp)/thank-you/", // Limit the segment values
      redirect: to => {
        // the function receives the target route as the argument
        // we return a redirect path/location here.
        return { path: `/brightspace/${to.params.segment}/thank-you/` };
      }
    },
    {
      path: "/thank-you/",
      component: ThankYou
    },
    {
      path:
        "/brightspace/:lang(es|pt-br|en-eu|en-mea|en-apac|nl)/:segment(k-12|he)/thank-you/",
      component: ThankYou
    },
    {
      path:
        "/:lang(es|pt-br|en-eu|en-mea|en-apac|nl)/:segment(k-12|he)/thank-you/",
      redirect: to => {
        // the function receives the target route as the argument
        // we return a redirect path/location here.
        return {
          path: `/brightspace/${to.params.lang}/${to.params.segment}/thank-you/`
        };
      }
    },
    {
      path: "/en-apac/corp", // Limit the segment values
      beforeEnter: (to, from, next) => {
        window.location =
          "https://www1.d2l.com/en-apac/corporate/live-demo-request/";
      }
    },
    ,
    {
      path: "/es/corp", // Limit the segment values
      beforeEnter: (to, from, next) => {
        window.location =
          "https://www1.d2l.com/es/corporativo/live-demo-request/";
      }
    },
    ,
    {
      path: "/pt-br/corp", // Limit the segment values
      beforeEnter: (to, from, next) => {
        window.location =
          "https://www1.d2l.com/pt-br/corporativa/pedido-de-demonstracao/";
      }
    },
    {
      path: "/:sandbox(masterclass)",
      // component: SandboxForm
      beforeEnter: () => {
        window.location = 'https://www.d2l.com/teaching-and-learning-studio/masterclass/';
      }
    },
    { // new try now redirects
      path: '/sandbox/:sandbox(bc|event|eku|ucmo|bill|suny|madison|uhs|irsc|kctcs|utdallas|utrgv)',
      beforeEnter: to => {
        window.location = `https://www.d2l.com/sandbox/${to.params.sandbox}/`;
      }
    },
    {
      path: "/sandbox/:sandbox",
      component: SandboxForm
    },
    {
      path: "/brightspace/:sandbox(creator)",
      // component: SandboxForm
      beforeEnter: () => {
        window.location.href = 'https://www.d2l.com/brightspace/creator/try-now/';
      }
    },
    {
      path: "/brightspace/:segment(mru|bc|suny|bill)", // Limit the segment values
      redirect: to => {
        // the function receives the target route as the argument
        // we return a redirect path/location here.
        return { path: `/sandbox/${to.params.segment}/` };
      }
    },
    {
      path: "/brightspace/:segment(all|sem|bill)",
      component: TrialForm
    },
    {
      path: "/brightspace/:segment(k-12|he|corp)", // Limit the segment values
      // component: TrialForm
      beforeEnter: ({ params }) => {
        let url;

        if ( params.segment === 'corp') {
          url = 'https://www.d2l.com/solutions/training-organizations/try-now/';
        } else if (params.segment === 'k-12') {
          url = 'https://www.d2l.com/solutions/k-12/try-now/';
        } else {
          url = 'https://www.d2l.com/solutions/higher-education/try-now/';
        }

        window.location.href = url;
      }
    },
    {
      path: "/:lang(es|pt-br|en-eu|en-mea|en-apac|en-in|nl)/brightspace/", // Limit the segment values
      beforeEnter: ({ params }) => {
        window.location.href = `https://www.d2l.com/${params.lang}/brightspace/try-now/`;
      }
    },
    {
      path: "/:lang(en-eu|en-mea)/brightspace/:segment(corp)", // Limit the segment values
      // component: TrialForm
      beforeEnter: ({ params }) => {
        window.location.href = `https://www.d2l.com/${params.lang}/brightspace/try-now/`;
      }
    },
    {
      path:
        "/:lang(es|pt-br|en-eu|en-mea|en-apac|en-in|nl)/brightspace/:segment(k-12|he)", // Limit the segment values
        // component: TrialForm,
        beforeEnter: ({ params }) => {
          window.location.href = `https://www.d2l.com/${params.lang}/brightspace/try-now/`;
        }
    },
    {
      path: "/:segment(curriculum|digital-resources)", // Limit the segment values
      component: TrialForm
    },
    {
      path: "/adventure/", // Limit the segment values
      beforeEnter: () => {
        window.location.href = `https://www.d2l.com/solutions/k-12/d2l-adventure/try-now/`;
      }
    },
    {
      path: "/:segment(mru|suny|bill)", // Limit the segment values
      redirect: to => {
        // the function receives the target route as the argument
        // we return a redirect path/location here.
        return { path: `/sandbox/${to.params.segment}/` };
      }
    },
    {
      path: "/:segment(k-12|he|corp|all|sem)", // Limit the segment values
      redirect: to => {
        // the function receives the target route as the argument
        // we return a redirect path/location here.
        return { path: `/brightspace/${to.params.segment}/` };
      }
    },
    {
      path: "/:lang(es|pt-br|en-eu|en-mea|en-apac|nl)/:segment(k-12|he)", // Limit the segment values
      redirect: to => {
        // the function receives the target route as the argument
        // we return a redirect path/location here.
        return { path: `/${to.params.lang}/brightspace/${to.params.segment}/` };
      }
    },
    {
      path: "/cookie-pass/:data",
      component: CookiePass
    },
    {
      path: "/:lang(es|pt-br|en-eu|en-mea|en-apac|en-in|nl)", // Limit the segment values
      redirect: to => {
        // the function receives the target route as the argument
        // we return a redirect path/location here.
        return { path: `/brightspace/${to.params.lang}/` };
      }
    },
    {
      name: "brightspace",
      path: "/brightspace/",
      // component: TrialForm,
      beforeEnter: () => {
        window.location.href = 'https://www.d2l.com/brightspace/try-now/';
      }
    },
    {
      path: "/",
      // redirect: to => {
        // the function receives the target route as the argument
        // we return a redirect path/location here.
        // return { path: "/brightspace/" };
      // }
      beforeEnter: () => {
        window.location.href = 'https://www.d2l.com/brightspace/try-now';
      }
    },
    {
      path: "*",
      beforeEnter: (to, from, next) => {
        window.location.href = 'https://www.d2l.com/brightspace/try-now';
      }
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js